import React from "react";
import DuplicateGroupTable from "./components/DuplicateGroupTable";

const DuplicateLawFirmsTab = () => (
  <DuplicateGroupTable
    entityType="law_firms"
    headingLabel="law firms"
    searchPlaceholder="Search by firm name"
  />
);

export default DuplicateLawFirmsTab;
